module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot5-8754b24c6f383f46a8b41a54f451dd68.png";